import { useTranslation } from "react-i18next";
import { API_URL } from "../../config";
import React, { useState } from "react";
import { GetDocumentGroupKey, UniqueByDocumentGroup } from "../Helpers/RequiredDocumentationGroup";

export function CustomReimbursementParticipantsView({ data, editMode, onClickDelete, onClickEdit, isManual = false, embedded = false }) {
    const { t } = useTranslation();
    const [expandedItems, setExpandedItems] = useState({});
    const toggleItem = (index) => setExpandedItems(prev => ({ ...prev, [index]: !prev[index] }));

    // One card per required documentation (entries without it fall back to their accounting)
    const dataSinDuplicadosDeAccounting = UniqueByDocumentGroup(data);

    const uniqueData = dataSinDuplicadosDeAccounting.filter((item) => {
        if (!item.additionalInfo || Object.keys(item.additionalInfo).length === 0) return false;
        return true;
    });

    const isReadOnlyProceeding = editMode === undefined && !onClickDelete && !onClickEdit;

    if (isReadOnlyProceeding && embedded) {
        if (!uniqueData || uniqueData.length === 0) return null;

        return (
            <div className="crv-embedded-wrapper">
                {uniqueData.map((item, index) => {
                    const programFileId = item?.additionalInfo?.programFileId;
                    const programCount = item?.additionalInfo?.programFileId != null ? item?.additionalInfo?.program : null;
                    const participantsFileId = item?.additionalInfo?.participantsFileId;
                    const programFileName = item?.additionalFileExtension || "";

                    return (
                        <div key={`participants-embedded-${item?.accountingId ?? index}`}>
                            {programCount !== null && programCount !== undefined && (
                                <div className="crv-embedded-field-mb">
                                    <div className="reimbursement-field-label">Antal deltagare:</div>
                                    <div className="reimbursement-field-value">{programCount}</div>
                                </div>
                            )}

                            {programFileId && (
                                <div className="reimbursement-file-items crv-embedded-file-mb">
                                    <a href={`${API_URL}/file?id=${programFileId}`} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                        <div className="reimbursement-file-item">
                                            <div className="reimbursement-file-left">
                                                <div className="reimbursement-file-icon">
                                                    <i className="bx bx-file" />
                                                </div>
                                                <div className="reimbursement-file-name">{programFileName || "Kallelse"}</div>
                                            </div>
                                            <i className="bx bx-chevron-right reimbursement-file-arrow" />
                                        </div>
                                    </a>
                                </div>
                            )}

                            {participantsFileId && !programFileId && (
                                <div className="reimbursement-file-items crv-embedded-file-mb">
                                    <a href={`${API_URL}/file?id=${participantsFileId}`} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                        <div className="reimbursement-file-item">
                                            <div className="reimbursement-file-left">
                                                <div className="reimbursement-file-icon">
                                                    <i className="bx bx-file" />
                                                </div>
                                                <div className="reimbursement-file-name">{programFileName || "Deltagarlista"}</div>
                                            </div>
                                            <i className="bx bx-chevron-right reimbursement-file-arrow" />
                                        </div>
                                    </a>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        );
    }

    return (
        <>
            {uniqueData && uniqueData.length > 0 ? (
                uniqueData.map((item, index) => {
                    const isExpanded = !!expandedItems[index];
                    const canEdit = item?.status === 'Förslag' && !editMode;
                    const programCount = item?.additionalInfo?.programFileId != null ? item?.additionalInfo?.program : null;
                    const programFileId = item?.additionalInfo?.programFileId;
                    const participantsFileId = item?.additionalInfo?.participantsFileId;
                    const programFileName = item?.additionalFileExtension || "";
                    const itemGroupKey = GetDocumentGroupKey(item);
                    const accountingNameTitle = [...new Set(
                        data
                            .filter(other => GetDocumentGroupKey(other) === itemGroupKey)
                            .map(other => other?.accountingName ? [...other.accountingName.matchAll(/\(([^()]*)\)/g)].pop()?.[1] || '' : '')
                            .filter(code => code !== '')
                    )].join(", ");

                    return (
                        <div key={`participant${index}`} className="crv-card-outer">
                            <div className="crv-header" onClick={() => toggleItem(index)}>
                                <div className="crv-header-left">
                                    <i className="bx bx-paperclip crv-header-icon" />
                                    <span className="crv-header-label">{t('reimbursement.participantsAndPrograms')} - {accountingNameTitle}</span>
                                </div>
                                <i className={`bx ${isExpanded ? "bx-chevron-up" : "bx-chevron-down"} crv-chevron`} />
                            </div>

                            <div className="crv-collapse" style={{ maxHeight: isExpanded ? "500px" : "0px" }}>
                                <div className="crv-collapse-inner">
                                    <div className={`crv-inner-card ${canEdit ? "crv-inner-card-with-buttons" : ""}`}>

                                        {programCount !== null && programCount !== undefined && (
                                            <div className="crv-row-mb">
                                                <span className="crv-label">Antal deltagare:</span>
                                                <span className="crv-value">{programCount}</span>
                                            </div>
                                        )}

                                        {item.additionalInfo?.participantsNames && (
                                            <div className="crv-row-gap crv-row-mb">
                                                <span className="crv-label-shrink">Deltagarlista:</span>
                                                <span className="crv-value-right">
                                                    {item.additionalInfo.participantsNames.split(/[\n,]+/).map((line, i) => (
                                                        <React.Fragment key={i}>{line.trim()}<br /></React.Fragment>
                                                    ))}
                                                </span>
                                            </div>
                                        )}

                                        {item.additionalInfo?.program && item.additionalInfo?.programFileId == null && (
                                            <div className="crv-row-gap crv-row-mb">
                                                <span className="crv-label-shrink">Deltagarlista:</span>
                                                <span className="crv-value-right">
                                                    {isManual ? "manuellt tillagda" : item.additionalInfo.program.split(/[\n,]+/).map((line, i) => (
                                                        <React.Fragment key={i}>{line.trim()}<br /></React.Fragment>
                                                    ))}
                                                </span>
                                            </div>
                                        )}

                                        {participantsFileId && (
                                            <div className={`crv-row-gap ${programFileId ? "crv-row-mb" : ""}`}>
                                                <span className="crv-label-shrink">Deltagarlista:</span>
                                                <a
                                                    href={`${API_URL}/file?id=${participantsFileId}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="crv-file-link"
                                                >
                                                    {programFileName || "Deltagarlista"}
                                                </a>
                                            </div>
                                        )}

                                        {programFileId && (
                                            <div className="crv-row-gap-last">
                                                <span className="crv-label-shrink">Bifogad fil:</span>
                                                <a
                                                    href={`${API_URL}/file?id=${programFileId}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="crv-file-link"
                                                >
                                                    {programFileName || "Kallelse"}
                                                </a>
                                            </div>
                                        )}
                                    </div>

                                    {canEdit && (
                                        <div className="crv-action-buttons">
                                            <button type="button" onClick={(e) => { e.stopPropagation(); onClickDelete(item, index); }} className="crv-btn-action">
                                                <i className="bx bx-trash-alt crv-icon-delete" />
                                            </button>
                                            <button type="button" onClick={(e) => { e.stopPropagation(); onClickEdit(item, index); }} className="crv-btn-action">
                                                <i className="bx bxs-pencil crv-icon-edit" />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })
            ) : null}
        </>
    );
}